module.exports = __webpack_public_path__ + "static/media/SR.a8d9edbd.png";